webpackJsonp([269109470040317],{

/***/ 1358:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---ignite-workshop-on-financial-modelling-a0e39f21c11f6a62c5ab.js